import { createContext } from "react"

const TeamsContext = createContext({})

export default TeamsContext
